module.exports = __webpack_public_path__ + "assets/fonts/2546e18b-3da2-44c0-be5d-0d9abeb7880d.833508a6.ttf";